import { useContext } from "react";
import { InvoiceTotalsInfo } from "../../../../generated/data-contracts";
import {
  AvisDescriptiveText,
  AvisValueRow,
} from "../../../shared/components/form";
import { AvisContext } from "../../../shared/context/AvisContext";

interface IInvoiceAmountToPayProps {
  amountTotalToPay: InvoiceTotalsInfo | undefined;
}
export function InvoiceAmountToPay(props: Readonly<IInvoiceAmountToPayProps>) {
  const { amountTotalToPay } = props;
  const { res } = useContext(AvisContext);

  return (
    <div className="invoices-to-pay">
      <AvisDescriptiveText
        textKey={
          amountTotalToPay?.owedTotal
            ? "portal_LIC_UnpaidInvoices_1"
            : "portal_LIC_UnpaidInvoices_2"
        }
      />
      {amountTotalToPay?.owedTotal && (
        <AvisValueRow
          rowTitle={res("licensees_Invoice_label_AmountToPayTotal")}
          rowValue={res(
            "value_format_Eur",
            amountTotalToPay.owedTotal.toFixed(2),
          )}
          className="pt-3 pb-3"
        />
      )}
    </div>
  );
}
